import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';

import AdminGateway from '~apis/admin';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { TCreateNewRoleReduxParams } from '~types/feat/admin';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchCreateNewRole(api: AdminGateway): SagaWatcherReturnType {
    yield takeEvery('admin/adminCreateNewRoleAttempt', handleCreateNewRole, api);
}

function* handleCreateNewRole(api: AdminGateway, data: PayloadAction<TCreateNewRoleReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        roleName,
        access,
        allBranchAccess,
    } = data.payload;

    const response = yield* call([api, api.createNewRole], {
        authToken,
        roleName,
        access,
        allBranchAccess,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.adminCreateNewRoleFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.adminCreateNewRoleSuccess());
        yield put(combinedActions.adminSetCreateNewRoleModalIsOpen(false));
        yield put(combinedActions.adminSetGetRoleListingIndex({ index: 0 }));
        yield put(combinedActions.adminGetRoleListingAttempt());

        toast.success(SuccessMessages.AdminCreateNewRoleSuccess);
    }
}
